import { apiRequest } from './httpClient';

// AI Personalization (backend/routers/ai_personalization.py) through the
// shared cookie HTTP client - same session, refresh and error shape as
// every other call. Settings only: nothing here affects meeting answers yet.
const BASE = '/api/ai-personalization';

const profilePath = (profileId, suffix = '') =>
  `${BASE}/profiles/${encodeURIComponent(profileId)}${suffix}`;

export function getAiStyles() {
  return apiRequest(`${BASE}/styles`);
}

export function getCustomProfiles() {
  return apiRequest(`${BASE}/profiles`);
}

export function getCustomProfile(profileId) {
  return apiRequest(profilePath(profileId));
}

export function createCustomProfile(profile) {
  return apiRequest(`${BASE}/profiles`, { method: 'POST', body: profile });
}

export function updateCustomProfile(profileId, changes) {
  return apiRequest(profilePath(profileId), { method: 'PATCH', body: changes });
}

// No body at all without a name: the backend then picks "<name> (copy)".
export function duplicateCustomProfile(profileId, options) {
  return apiRequest(profilePath(profileId, '/duplicate'), {
    method: 'POST',
    body: options && options.name ? { name: options.name } : undefined,
  });
}

export async function deleteCustomProfile(profileId) {
  await apiRequest(profilePath(profileId), { method: 'DELETE' });
}

export function getAiSelection() {
  return apiRequest(`${BASE}/selection`);
}

export function saveAiSelection(selection) {
  return apiRequest(`${BASE}/selection`, { method: 'PUT', body: selection });
}

export async function clearAiSelection() {
  await apiRequest(`${BASE}/selection`, { method: 'DELETE' });
}
